/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, coloredScrollBar } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- LABEL ASSIGNMENT FIELD : STYLES --------------- ++++++++++ */
export default theme => ({
    labelassignmentfield: {
        position: 'relative',
        width: '100%',
        '& .field': {
            width: '100%',
            '& .formelement': {
                height: '100%',
                padding: replacePXinStringWithEM(`7px 10px`),
                '&:hover': {
                    filter: 'none'
                }
            }
        },
        '& .assignmentfieldlabel': {
            display: 'flex',
            '& .tooltip': {
                '& .active': {
                    zIndex: 20000
                }
            }
        },
        '& .name-dropdownmenu':{
            position: 'absolute',
            width: '100%',
            height: 'auto',
            zIndex: 1,
            maxHeight: pxToEm(428),
            display: 'flex',
            flexDirection: 'column',
            padding: replacePXinStringWithEM('10px'),
            backgroundColor: theme.color.light.light.swatch,
            boxShadow: theme.boxShadow.small,
            '& .name-dropdownmenuitems':{
                overflow: 'scroll',
                overflowX: 'hidden',
                extend: coloredScrollBar(theme.color.primary.medium.swatch)
            },
            '&.active-false': {
                height: pxToEm(0),
                padding: 0,
                overflow: 'hidden',
                pointerEvents: 'none',
                transition: 'all .15s',
                opacity: 0
            }
        },

	}
});
